import { render } from "./MoreEvents.vue?vue&type=template&id=5fc3fa0a&scoped=true"
import script from "./MoreEvents.vue?vue&type=script&lang=js"
export * from "./MoreEvents.vue?vue&type=script&lang=js"

import "./MoreEvents.vue?vue&type=style&index=0&id=5fc3fa0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc3fa0a"]])

export default __exports__